import type { LoginMutation } from "@/graphql/generated/graphql";

type LoginPayload = LoginMutation["login"];
type FederatedLoginPayload = Extract<LoginPayload, { __typename: "RequiresFederatedLoginResponse" }>;

export const isFederatedLoginHandoff = (payload: LoginPayload): payload is FederatedLoginPayload =>
  payload.__typename === "RequiresFederatedLoginResponse" && payload.startUrl.length > 0;
